//error.js
import React from 'react'

const Error = ({ error }) => {
	return (
		<div className='p-10 w-full text-center text-xl font-bold text-rose-600'>
			{typeof error === 'string' ? error : JSON.stringify(error)}
		</div>
	)
}

export default Error
